import { render, staticRenderFns } from "./EMail.vue?vue&type=template&id=84d48182&"
import script from "./EMail.vue?vue&type=script&lang=js&"
export * from "./EMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports